<div class="access-denied-container">
  <div class="access-denied-content">
    <div class="error-icon">
      <i class="fa fa-ban"></i>
    </div>

    <h1 class="error-title">Access Denied</h1>

    <p class="error-message">
      You don't have permission to access this page. Please contact your administrator
      if you believe this is an error.
    </p>

    <div class="action-buttons">
      <button class="btn btn-primary" (click)="goBack()" aria-label="Go back to previous page">
        <i class="fa fa-arrow-left"></i>
        Go Back
      </button>

      <button class="btn btn-secondary" (click)="goHome()" aria-label="Go to home page">
        <i class="fa fa-home"></i>
        Go Home
      </button>
    </div>
  </div>
</div>